import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Select } from '../components/ui/Select';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { X} from 'lucide-react';
import { useToast } from "../components/ui/toast-provider";
import { MunicipioService } from "../services/municipioService";
import { DepartamentoResponse } from '../types/puesto';
import { DepartamentoService } from '../services/departamentoService';

export default function editarMunicipio({ isOpen, onGuardado, onClose, idEditando}: { isOpen: boolean; onGuardado: () => void; onClose: () => void; idEditando: number}) {

    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");
    const [editando, setEditando] = useState(false);

    const [departamentos, setDepartamentos] = useState<DepartamentoResponse[]>([]);

    const { addToast } = useToast();

    const [formulario, setFormulario] = useState({
        municipio: '',
        idDepartamento: ''
    });

    const resetFormulario = () => {
        setFormulario({
        municipio: '',
        idDepartamento: ''
        });
    };

    const cargarDepartamentos = async (id: number) => {
        try {
          setIsLoading(true);
          if(id!=0){
            const res = await DepartamentoService.getConUsado(id);
            setDepartamentos(res.data);
          }else{
            const res = await DepartamentoService.getAll(true);
            setDepartamentos(res.data);
          }
        } catch (err) {
          setError("Error al cargar departamentos");
        } finally {
          setIsLoading(false);
        }
      };

    const cargarMunicipio = async (id: number) => {
        try {
            setIsLoading(true);
            if(id!=0){
                const response = await MunicipioService.getById(id);
                const municipio = response.data;
                setFormulario({
                    municipio: municipio.municipio,
                    idDepartamento: municipio.idDepartamento
                })

                const idDepartamento = municipio.idDepartamento;
                await cargarDepartamentos(idDepartamento);
            }else{
                await cargarDepartamentos(0);
            }
        } catch (err) {
            console.error("Error al cargar municipio: " + err);
        } finally {
            setIsLoading(false);
        }
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            if (editando) {
                await MunicipioService.update(idEditando, {
                    municipio: formulario.municipio,
                    idDepartamento: Number(formulario.idDepartamento)
                });
            } else {
                await MunicipioService.create({
                    municipio: formulario.municipio,
                    idDepartamento: Number(formulario.idDepartamento)
                });
            }

            addToast(editando ? "Municipio actualizado exitosamente" : "Municipio creado exitosamente");
            resetFormulario();
            onGuardado();
        } catch (err:any) {
              const message =
                err?.response?.data?.message ||
                "Error inesperado al editar";

            setError(message);
        }
    }

    useEffect(() => {
        if(isOpen) {
            resetFormulario();
            if (idEditando !== 0) {
                cargarMunicipio(idEditando);
            }else{
                cargarDepartamentos(0);
            }
            setEditando(idEditando !== 0);
            setError("");
        }
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }
    return (
        <div className="fixed inset-0 bg-opacity-50 flex items-center justify-center z-50">
            <div className="rounded-2xl w-full max-w-2xl shadow-lg relative max-h-[90vh] overflow-y-auto scrollbar-thin">
                <Card>
                    <CardHeader className="flex flex-row items-center justify-between">
                        <CardTitle>{editando ? 'Editar Municipio' : 'Crear Municipio'}</CardTitle>
                        <button
                        onClick={onClose}
                        className="p-2 hover:bg-destructive/10 rounded-lg transition-colors"
                        >
                        <X className="w-5 h-5 text-destructive" />
                        </button>
                    </CardHeader>
                    <CardContent>
                        <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <Input
                            label="Municipio"
                            type="text"
                            value={formulario.municipio}
                            onChange={(e) =>
                                setFormulario({ ...formulario, municipio: e.target.value })
                            }
                            placeholder="Ingrese el municipio"
                            required
                            />
                            <Select
                            label="Departamento"
                            value={formulario.idDepartamento}
                            onChange={(e) =>
                                setFormulario({ ...formulario, idDepartamento: e.target.value })
                            }
                            options={departamentos.map((r) => ({ value: (r.idDepartamento!).toString(), label: r.departamento }))}
                            required
                            />
                        </div>
                        <div className = "flex justify-center">
                        {error && (
                            <span className="text-destructive text-center text-sm">{error}</span>
                        )}
                        </div>
                        <div className="flex gap-2">
                            <Button type="submit" variant="primary">
                            {editando ? 'Editar Municipio' : 'Crear Municipio'}
                            </Button>
                            <Button type="button" variant="ghost" onClick={onClose}>
                            Cancelar
                            </Button>
                        </div>
                        </form>
                    </CardContent>
                </Card>
            </div>
        </div>
    )

}